<div class="map-container" #map></div>
<div class="row">
  <table>
    <tr *ngFor='let l of locations; let indx = index' [class.selected]="selectedIndex === indx">
      <td><a (click)="onClick(indx)">{{l.address}}</a></td>
      <td>{{l._when | date : 'dd/MM/yy HH:mm'}}</td>
    </tr>
  </table>
</div>

